import { render, staticRenderFns } from "./addGoods.vue?vue&type=template&id=12da63e0&scoped=true"
import script from "./addGoods.vue?vue&type=script&lang=js"
export * from "./addGoods.vue?vue&type=script&lang=js"
import style0 from "./addGoods.vue?vue&type=style&index=0&id=12da63e0&prod&scoped=true&lang=css"
import style1 from "./addGoods.vue?vue&type=style&index=1&id=12da63e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12da63e0",
  null
  
)

export default component.exports